import uploadErrorsTemplate from './upload-errors.html';

/**
 * @param {import('angular').ITemplateCacheService} $templateCache
 */
export default /* @ngInject */ $templateCache => {
	$templateCache.put('upload-errors.html', uploadErrorsTemplate);
};
